import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".AppCheckbox-module_disabled__-9F7t {\n  pointer-events: none;\n  cursor: not-allowed !important;\n}";
var Style = {"disabled":"AppCheckbox-module_disabled__-9F7t"};
styleInject(css_248z);

export { Style as default };
//# sourceMappingURL=AppCheckbox.module.scss.js.map
